import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        {/* Rounded square background */}
        <rect
          id="Shape"
          x="1"
          y="1"
          width="76"
          height="88"
          rx="12"
          ry="12"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="var(--navy)"
        />
        {/* Letter S */}
        <text
          x="39"
          y="64"
          textAnchor="middle"
          fill="currentColor"
          fontFamily="Inter, sans-serif"
          fontWeight="700"
          fontSize="58">
          S
        </text>
      </g>
    </g>
  </svg>
);

export default IconLogo;
